<template>
	<div class="row">
		<div class="col-lg-3 col-sm-6 col-xs-12">
			<div class="white-box">
				<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/customers'">
					<h3 class="box-title">CLIENTES</h3>
				</router-link>
				<ul class="list-inline two-part">
					<li><i class="icon-people text-info"></i></li>
					<li class="text-right"><span class="counter">{{ customers }}</span></li>
				</ul>
			</div>
		</div>
		<div v-if="user.hasPackage(2)" class="col-lg-3 col-sm-6 col-xs-12">
			<div class="white-box">
				<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets'">
					<h3 class="box-title">PRESUPUESTOS</h3>
				</router-link>
				<ul class="list-inline two-part">
					<li><i class="fa fa-clipboard fa-fw text-purple"></i></li>
					<li class="text-right"><span class="counter">{{ budgets }}</span></li>
				</ul>
			</div>
		</div>
		<div class="col-lg-3 col-sm-6 col-xs-12">
			<div class="white-box">
				<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects'">
					<h3 class="box-title">PROYECTOS</h3>
				</router-link>
				<ul class="list-inline two-part">
					<li><i class="ti-folder fa-fw text-danger"></i></li>
					<li class="text-right"><span class="">{{ projects }}</span></li>
				</ul>
			</div>
		</div>
		<div class="col-lg-3 col-sm-6 col-xs-12">
			<div class="white-box">
				<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/tasks'">
					<h3 class="box-title">TAREAS</h3>
				</router-link>
				<ul class="list-inline two-part">
					<li><i class="ti ti-flag-alt fa-fw text-success"></i></li>
					<li class="text-right"><span class="">{{ tasks }}</span></li>
				</ul>
			</div>
		</div>

		<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
			<new-customers-per-month
				ref="newCustomersPerMonth"
				:user="user"
				:isAuth="isAuth">
			</new-customers-per-month>
		</div>

		<div v-if="user.hasPackage(2)" class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
			<new-budgets-per-day
				ref="newBudgetsPerDay"
				:user="user"
				:isAuth="isAuth">
			</new-budgets-per-day>
		</div>
		
		<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
			<new-projects-per-month
				ref="newProjectsPerMonth"
				:user="user"
				:isAuth="isAuth">
			</new-projects-per-month>
		</div>
		<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
			<status-tasks
				ref="statusTasks"
				:user="user"
				:isAuth="isAuth">
			</status-tasks>
		</div>
	</div>
</template>

<script>
	import newCustomersPerMonth from '../views/charts/newCustomersPerMonth.vue'
	import newBudgetsPerDay from '../../management/dashboard/views/charts/newBudgetsPerDay.vue'
	import newProjectsPerMonth from '../../projects/dashboard/views/charts/newProjectsPerMonth.vue'
	import statusTasks from '../../projects/dashboard/views/charts/statusTasks.vue'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'new-customers-per-month': newCustomersPerMonth,
			'new-budgets-per-day': newBudgetsPerDay,
			'new-projects-per-month': newProjectsPerMonth,
			'status-tasks': statusTasks,
		},
		data () {
			return {
				customers: 0,
				budgets: 0,
				projects: 0,
				tasks: 0,
			}
		},
		created() {
			//this.init()
			this.redirecToPackage()
		},
		methods: {
			init() {
				var that = this
				this.getResume()
			},
			refresh() {
				var that = this
				setTimeout(function() {
					that.$refs.newCustomersPerMonth.reload()
					that.$refs.newBudgetsPerDay.reload()
					that.$refs.newProjectsPerMonth.reload()
					that.$refs.statusTasks.reload()
					that.refresh()
				}, 5000);
			},
			getResume() {
				this.$http.get('admin/resume')
				.then(response => {
					this.customers = response.body.customers
					this.budgets = response.body.budgets
					this.projects = response.body.projects
					this.tasks = response.body.tasks
				})
			},
			redirecToPackage() {
				if(this.$platform) {
					if(this.$platform.setting) {
						var main_package_id = this.$platform.setting.main_package_id
						if(main_package_id) {
							if(this.$platform.hasPackage(main_package_id)) {
								if(main_package_id == 1) {
									this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/cms')
								}
								if(main_package_id == 2) {
									this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management')
								}
								if(main_package_id == 3) {
									this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/projects')
								}
							}
						}
					}
				}
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/dashboard/layout/Dashboard.vue